export const MapConstants = {
    GET_MAP: 'GET_MAP',
    SET_MAP: 'SET_MAP'
};